<template>
  <UploadDropzone
    v-bind="$attrs"
    ref="uploadDropzoneRef"
    :accept="accept"
    :upload-icon="uploadIcon"
    :upload-text="uploadText"
  />
</template>

<script setup>
import { ref } from 'vue'
import constants from '@/generated/constants'
import UploadDropzone from './upload-dropzone.vue'

const uploadDropzoneRef = ref(null)
const isSupportInputCapture = document.createElement('input').capture !== undefined
const accept = isSupportInputCapture ? 'video/*' : constants.GLOBAL.VIDEO_EXTENSION_ALLOW_LIST.join(',')
const uploadIcon = isSupportInputCapture ? 'camera' : 'cloud-upload'
let uploadText = 'Click or Drag File to Upload Video'
if (isSupportInputCapture) {
  uploadText = 'Record a video using your device’s camera or upload one from your library. You’ll be able to preview your video before submitting it.'
}

defineExpose({
  reset: () => {
    uploadDropzoneRef.value.reset()
  },
})
</script>
